<template>
    <div class="tooltip-container">
        <img
            src="@/static/images/icons/info.svg"
            alt="info"
            @mouseenter="onMouseEnter"
            @mouseleave="onMouseLeave"
            @click="onClick"
        />
        <div
            class="tooltip-text"
            v-if="isToolTipShowing"
            :style="tooltipStyle"
        >
            <span v-if="message" v-html="message"></span>
        </div>
    </div>
</template>

<script>
export default {
    name: "TooltipComponent",
    props: {
        message: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            isToolTipShowing: false,
            tooltipX: 0,
            tooltipY: 0,
            isMobile: false,
        }
    },
    computed: {
        tooltipStyle() {
            return `top: ${this.tooltipY}px; left: ${this.tooltipX}px; max-width: ${
                this.isMobile ? "200px" : "300px"
            };`;
        }
    },
    mounted() {
        // Détecte si l'appareil est mobile
        this.isMobile = /Mobi|Android/i.test(navigator.userAgent);
    },
    methods: {
        updateTooltipPosition(event) {
            const iconRect = event.target.getBoundingClientRect();
            this.tooltipX = iconRect.left + iconRect.width / 2;
            this.tooltipY = iconRect.top - 16;
        },
        onMouseEnter(event) {
            if (!this.isMobile) {
                this.updateTooltipPosition(event);
                this.isToolTipShowing = true;
            }
        },
        onMouseLeave() {
            if (!this.isMobile) {
                this.isToolTipShowing = false;
            }
        },
        onClick(event) {
            if (this.isMobile) {
                event.stopPropagation();
                this.updateTooltipPosition(event);
                this.isToolTipShowing = true;
                document.addEventListener("click", this.handleOutsideClick);
                document.addEventListener("touchstart", this.handleOutsideClick);
            }
        },
        handleOutsideClick(event) {
            if (!this.$el.contains(event.target)) {
                this.isToolTipShowing = false;
                document.removeEventListener("click", this.handleOutsideClick);
                document.removeEventListener("touchstart", this.handleOutsideClick);
            }
        }
    }
}
</script>

<style scoped lang="scss">
img {
    width: 24px;
    height: 24px;
}

.tooltip-container {
    margin-left: 8px;

    .tooltip-text {
        position: fixed;
        z-index: 50;
        background-color: rgba(28, 28, 28, 0.90);
        color: white;
        border-radius: 8px;
        padding: 10px 16px;
        transform-origin: bottom center;
        transform: translate(-50%, -100%);
        /* La max-width est définie via le style inline */
    }
    .tooltip-text::after {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid rgba(28, 28, 28, 0.90);
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
    }
}
</style>
